import { render } from "./EditableKpiType.vue?vue&type=template&id=729ed88f&ts=true"
import script from "./EditableKpiType.vue?vue&type=script&lang=ts"
export * from "./EditableKpiType.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__